import React, {Component} from "react";
import {Redirect} from 'react-router';
//import AlertBox from 'components/AlertBox/alertbox.jsx';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';

import withStyles from "@material-ui/core/styles/withStyles";
import Assignment from "@material-ui/icons/Assignment";
import FormControl from "@material-ui/core/FormControl";
import Switch from "@material-ui/core/Switch";
import InputLabel from "@material-ui/core/InputLabel";
import AutoCompleteClinicalNotes from "components/Search/AutoCompleteClinicalNotes.jsx";
import AutoCompleteMedication from "components/Search/AutoCompleteMedication.jsx";
import AutoCompletePrescriptionTemplate from "components/Search/AutoCompletePrescriptionTemplate.jsx";
import Modal from '@material-ui/core/Modal';

import FormControlLabel from "@material-ui/core/FormControlLabel";
import api from "../../api/Api";
import {NavLink} from "react-router-dom";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
// @material-ui/core components
import {serverError} from '../../redux/global'


import SearchComponent from "components/Search/AutoCompletePatient.jsx";
import Grid from '@material-ui/core/Grid';

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Card from "components/Card/Card.jsx";
import TextField from '@material-ui/core/TextField';
import CardHeader from "components/Card/CardHeader.jsx";
import CardText from "components/Card/CardText.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import {
    verifyEmail,
    verifyName,
    verifyAlphaNum,
    verifyNumber,
    verifyPhoneNumber, getDateConverter, currentDate,
    getReportTypes, isClinicMasterOrClinic, getClinicUserId, clinicmaster_id, dashboardRouter
} from '../../util/globalHelper'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'
import {
    saveSearchPrescription
} from '../../redux/global'
// style for this view
import validationFormsStyle from "assets/jss/material-dashboard-pro-react/views/validationFormsStyle.jsx";
import ReportUpload from "../CustomUpload/ReportUpload";
import Loader from '../../components/Loader'
import {Editor} from 'react-draft-wysiwyg';
import {EditorState, convertToRaw, ContentState, convertFromHTML} from 'draft-js';
import htmlToDraft from 'html-to-draftjs';
import draftToHtml from 'draftjs-to-html';
import TagsInput from 'react-tagsinput'
import 'react-tagsinput/react-tagsinput.css'

var removeByAttr = function (arr, attr, value) {
    var i = arr.length;
    while (i--) {
        if (arr[i]
            && arr[i].hasOwnProperty(attr)
            && (arguments.length > 2 && arr[i][attr] === value)) {

            arr.splice(i, 1);

        }
    }
    return arr;
}


class CreateBilling extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: "",
            nameState: "",
            reportTitle: "",
            reportTitleState: "",
            contactNumber: "",
            contactNumberState: "",
            email: "",
            emailState: "",
            paid: false,
            descriptionState: "",
            description: "",
            fileUrl: "",
            checkedA: true,
            save_template: false,
            last_name: "",
            last_nameState: "",
            number: "",
            numberState: "",
            username: "",
            usernameState: "",
            password: "",
            passwordState: "",
            simpleSelect: "",
            imageurl: '',
            clinicMasterList: null,
            doctorList: null,
            clickedId: null,
            clinicname: "",
            clinicnameState: "",
            adminName: "",
            adminNameState: "",
            report_link: [],
            autoCompleteValue: "",
            companyNumber: "",
            companyNumberState: "",
            alert: null,
            open: true,
            generatedclinicmaster_id: "",
            propss: props,
            clinicmaster_id: "",
            doctor_id: "",
            clinic_id: "",
            patient: null,
            clinicsData: null,
            editorState: EditorState.createEmpty(),
            ref_by: "",
            age: "",
            remarks: "",
            ref_byState: "",
            remarksState: "",
            ageState: "",
            clinicDetail: null,
            secondaryNumber: [],
            secondaryNumberState: [],
            investigation: [],
            medication: [],
            gender: "",
            invoice_numberState: "",
            invoice_number: "",
            custom_message: "",
            custom_messageState: "",
            templates: [],
            templatesPres: [],
            selectedPill: null,
            Complaints: [""],
            Observation: [""],
            Diagnosis: [""],
            pulse: "",
            weight: "",
            bloodPressure: "",
            temperature: "",
            rate: "",
            duration: ["days"],
            selectTemplate: 0
        };
        this.typeClick = this.typeClick.bind(this);
        this.onChangeSelect = this.onChangeSelect.bind(this);
        this.setPhoneNumber = this.setPhoneNumber.bind(this);
        this.setReportTitle = this.setReportTitle.bind(this);
        this.onEditorStateChange = this.onEditorStateChange.bind(this);
        this.handleChangeSecondayNumber = this.handleChangeSecondayNumber.bind(this);
        this.changeSecondaryNumbers = this.changeSecondaryNumbers.bind(this);
        this.handleChangeInvestigation = this.handleChangeInvestigation.bind(this);
        this.handleChangeMedication = this.handleChangeMedication.bind(this);
        this.saveMedication = this.saveMedication.bind(this);
        this.saveInvestigation = this.saveInvestigation.bind(this);
        this.onChangeText = this.onChangeText.bind(this);
        this.hideAlert = this.hideAlert.bind(this);
        this.setNotesValue = this.setNotesValue.bind(this);
        this.onSelectDuration = this.onSelectDuration.bind(this);
        this.newNoteAdd = this.newNoteAdd.bind(this);
        this.setTemplate = this.setTemplate.bind(this);

    }

    handleSimple = event => {
        this.setState({[event.target.name]: event.target.value});
    };

    componentWillReceiveProps(nextProps) {
        if (nextProps.searchPrescription !== this.props.searchPrescription && nextProps.searchPrescription !== null) {
            this.setState({alert: null}, () => {
                this.GetTemplatesAlert();
            });
        }
    }


    onEditorStateChange(editorState) {
        this.setState({
            editorState,
        });
    };

    onChangeText(e, name) {
        this.setState({[name]: e.target.value})
    }

    hideAlert() {
        this.setState({alert: null})
    }

    setTemplate() {
        let data = this.state.templatesPres[this.state.selectTemplate];
        this.setState({
            "medication": data.medicines ? data.medicines : "",
            "investigation": data.investigation ? data.investigation : "",
            "Complaints": data.clinical_notes.complaint ? [data.clinical_notes.complaint] : "",
            "Observation": data.clinical_notes.observations ? [data.clinical_notes.observations] : "",
            "Diagnosis": data.clinical_notes.diagnosis ? [data.clinical_notes.diagnosis] : "",
            "alert": null
        })
    }


    handleImageUrl(url) {
        var reportCount = this.state.report_link.length > 0 ? this.state.report_link.length : "";
        this.setState({
            // imageurl: url,
            report_link: this.state.report_link.concat({
                "link": url,
                "type": `${this.state.simpleSelect !== "" ? this.state.simpleSelect : "Others"}`
            })
        }, () => {
            // this.setState({imageurl: ''})
        });
    }

    removeReport(url) {
        this.setState({report_link: this.state.report_link.splice(this.state.report_link.indexOf(this.state.report_link.find(item => item.link === url)), 1)})
    }

    changeExistingReport(url, preUrl) {
        let objIndex = this.state.report_link.length > 0 ? this.state.report_link.findIndex((obj => obj.link === preUrl)) : null;
        if (this.state.report_link.length > 0) {
            this.state.report_link[objIndex].link = url
        }
    }

    getSuggestionValue = (suggestion) => {
        // this.setState({
        //     // clickedId: suggestion._id,
        //     notes: suggestion,
        //     name: suggestion.text,
        //     // nameState: 'success',
        //     // contactNumber: suggestion.user_id.contact,
        //     // contactNumberState: 'success',
        //     // email: suggestion.user_id.email,
        //     // emailState: 'success',
        //     // age: suggestion.user_id.gender && suggestion.user_id.age !== "" ? suggestion.user_id.age : "",
        //     // gender: suggestion.user_id.gender && suggestion.user_id.gender !== "" ? suggestion.user_id.gender === "male" ? "M" : "F" : ""
        // });
        return suggestion.text

    }


    getSuggestionPatientValue = (suggestion) => {
        this.setState({
            clickedId: suggestion._id,
            patient: suggestion,
            name: suggestion.user_id.name,
            nameState: 'success',
            contactNumber: suggestion.user_id.contact,
            contactNumberState: 'success',
            email: suggestion.user_id.email,
            emailState: 'success',
            age: suggestion.user_id.gender && suggestion.user_id.age !== "" ? suggestion.user_id.age : "",
            gender: suggestion.user_id.gender && suggestion.user_id.gender !== "" ? suggestion.user_id.gender === "male" ? "M" : "F" : ""
        });
        return suggestion.user_id.contact

    }

    setPhoneNumber(value) {
        this.setState({autoCompleteValue: value})
    }

    componentDidMount() {
        this.CallReadApi(this.props.id.match.params.patientID)
        var postBody = {
            "text": ""
        };
        api.getPrescriptionTemplates(postBody).then((result) => {
            this.setState({templatesPres: result ? result.data.data : []});
        }).catch(error => {
            this.props.serverError(true);
        })
        ;
        this.setState({clickedId: this.props.id.match.params.patientID})

    }

    CallReadApi = (id) => {
        isClinicMasterOrClinic() === "" ? api.listClinicMaster().then(json => {
                this.setState({clinicMasterList: json.data.data})
            }).catch(error => {
                this.props.serverError(true);
            })
            : this.setState({
                clinicMasterList: {},
                clinicmaster_id: clinicmaster_id(),
                clinic_id: getClinicUserId()
            });
        var postBody = {
            "clinic_master_id": clinicmaster_id(),
            "_id": id
        };
        if (id) {
            api.fetchPatientDetailsByClinicMasterAndPatientID(postBody).then(json => {
                this.setState({patientDetail: json.data.data[0]}, () => {
                    this.setState({
                        name: this.state.patientDetail.user_id.name, nameState: 'success',
                        autoCompleteValue: this.state.patientDetail.user_id.contact,
                        contactNumber: this.state.patientDetail.user_id.contact,
                        contactNumberState: 'success',
                        email: this.state.patientDetail.user_id.email,
                        emailState: 'success',
                    })
                })
            }).catch(error => {
                this.props.serverError(true);
            })
        }

        api.getAllDoctors().then(json => {
            this.setState({doctorList: json.data.data})
        }).catch(error => {
            this.props.serverError(true);
        })
        ;
    }

    onChangeSelect(e) {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState(state);
    }

    setReportTitle(value) {
        this.setState({autoCompleteReportValue: value})
    }

    getReportTitleSuggestionValue = (suggestion) => {
        this.setState({
            report: suggestion,
            templatesPres: [suggestion],
            reportTitle: suggestion.remark,
            alert: null
            // simpleSelect: suggestion.type,
            // templates: suggestion.templates
            // description: suggestion.description,
            // descriptionState: 'success',
            // editorState: EditorState.createWithContent(ContentState.createFromBlockArray((htmlToDraft(suggestion.html.replace(/10px;/gi, "12px"))).contentBlocks)),
        }, () => {
            this.GetTemplatesAlert();
        });
        return suggestion.remark

    };

    componentWillUnmount() {
        this.setState({
            name: "",
            nameState: "",
            reportTitle: "",
            reportTitleState: "",
            contactNumber: "",
            contactNumberState: "",
            email: "",
            emailState: "",
            paid: false,
            descriptionState: "",
            description: "",
            fileUrl: "",
            checkedA: true,
            last_name: "",
            last_nameState: "",
            number: "",
            numberState: "",
            username: "",
            usernameState: "",
            password: "",
            passwordState: "",
            simpleSelect: "",
            imageurl: '',
            clinicMasterList: null,
            clickedId: null,
            clinicname: "",
            clinicnameState: "",
            adminName: "",
            adminNameState: "",
            report_link: [],
            gender: ""
        })

    }

    setNotesValue(type, value, index) {
        this.state[type][index] = value
        this.setState({[type]: this.state[type]});
    }

    newNoteAdd(type) {
        let a = [""];
        let b = this.state[type].concat(a);
        this.setState({[type]: b});
    }

    render() {
        const {classes} = this.props;
        const {clinicLis, clinicsData, clinicMasterList, editorState} = this.state;
        if ((this.state.clinicmaster_id && this.state.clinicsData === null) || (this.state.clinicsData !== null && (this.state.clinicsData[0] ? this.state.clinicsData[0].clinic_master_id !== this.state.clinicmaster_id : true) || this.state.clinicsData === [])) {
            this.getMyclinicFromClicnicMaster(this.state.clinicmaster_id)
        }
        if (this.state.clinicMasterList)
            return (
                <div>
                    <GridContainer>
                        {this.state.alert}
                        <GridItem xs={12} sm={12} md={12}>
                            <Card>
                                <CardHeader color="info" text>
                                    <CardText color="info">
                                        <h4 className={classes.cardTitle}>Create Billing</h4>
                                    </CardText>

                                </CardHeader>
                                <CardBody>
                                    <form>
                                        <GridContainer>
                                            {isClinicMasterOrClinic() === "" ?
                                                <GridItem xs={12} sm={6} className="centerDiv">
                                                    <FormControl
                                                        fullWidth>
                                                        <InputLabel
                                                            htmlFor="clinicmaster_id">
                                                            Clinic Master
                                                        </InputLabel>
                                                        <Select
                                                            value={this.state.clinicmaster_id}
                                                            onChange={this.onChangeSelect}
                                                            inputProps={{
                                                                name: "clinicmaster_id",
                                                                id: "clinicmaster_id"
                                                            }}
                                                        >
                                                            <MenuItem
                                                                disabled
                                                            >
                                                                Select Clinic
                                                            </MenuItem>
                                                            {clinicMasterList.map((x) => {
                                                                return <MenuItem key={Math.random()}
                                                                                 style={{height: "1.8em"}}
                                                                                 value={x.clinicmaster_id}>{x.clinicmaster_name ? x.clinicmaster_name : "No Name"}</MenuItem>
                                                            })}
                                                        </Select>
                                                    </FormControl>
                                                    <br/>
                                                </GridItem> : null}
                                            {isClinicMasterOrClinic() === "" || isClinicMasterOrClinic() ?
                                                <GridItem xs={12} sm={6} className="centerDiv">

                                                    {this.state.clinicsData && this.state.clinicsData[0] && this.state.clinicsData[0].clinic_master_id === this.state.clinicmaster_id ?
                                                        <FormControl
                                                            fullWidth>
                                                            <InputLabel
                                                                htmlFor="clinic_id">
                                                                Clinic
                                                            </InputLabel>
                                                            <Select
                                                                value={this.state.clinic_id}
                                                                onChange={this.onChangeSelect}
                                                                inputProps={{
                                                                    name: "clinic_id",
                                                                    id: "clinic_id"
                                                                }}
                                                            >
                                                                <MenuItem
                                                                    disabled
                                                                >
                                                                    Select Clinic
                                                                </MenuItem>
                                                                {clinicsData.length > 0 ? clinicsData.map((x) => {
                                                                    return <MenuItem key={Math.random()}
                                                                                     style={{height: "1.8em"}}
                                                                                     value={x._id}>{x.name ? x.name : "No Name"}</MenuItem>
                                                                }) : null}
                                                            </Select>
                                                        </FormControl> : null}
                                                </GridItem> : null}
                                            <GridItem xs={12} sm={6}>

                                                {this.props.id.match.params.patientID ? <CustomInput
                                                        labelText=" Phone Number"
                                                        success={this.state.contactNumberState === "success"}
                                                        error={this.state.contactNumberState === "error"}
                                                        id="url"
                                                        formControlProps={{
                                                            fullWidth: true,
                                                            required: true
                                                        }}
                                                        inputProps={{
                                                            onChange: event => this.change(event, "contactNumber", "phonenumber"),
                                                            value: this.state.contactNumber,

                                                        }}
                                                    /> :
                                                    <SearchComponent setPhoneNumber={this.setPhoneNumber}
                                                                     name={this.state.name}
                                                                     getSuggestionValue={this.getSuggestionPatientValue}/>}
                                            </GridItem>
                                            <GridItem xs={12} sm={6}>
                                                <CustomInput
                                                    labelText="Invoice Number"
                                                    success={this.state.invoice_numberState === "success"}
                                                    error={this.state.invoice_numberState === "error"}
                                                    id="invoice_number"
                                                    formControlProps={{
                                                        fullWidth: true,
                                                        required: true
                                                    }}
                                                    inputProps={{
                                                        onChange: event =>
                                                            this.change(event, "invoice_number", "novalidation"),
                                                        value: this.state.invoice_number,

                                                    }}
                                                />

                                            </GridItem>
                                            <GridItem xs={12} sm={6}>
                                                <CustomInput
                                                    labelText="Name"
                                                    success={this.state.nameState === "success"}
                                                    error={this.state.nameState === "error"}
                                                    id="name"
                                                    formControlProps={{
                                                        fullWidth: true,
                                                        required: true
                                                    }}
                                                    inputProps={{
                                                        onChange: event =>
                                                            this.change(event, "name", "name"),
                                                        value: this.state.name,

                                                    }}
                                                />

                                            </GridItem>
                                            <GridItem xs={12} sm={6}>
                                                <CustomInput
                                                    labelText="Email"
                                                    success={this.state.emailState === "success"}
                                                    error={this.state.emailState === "error"}
                                                    id="email"
                                                    formControlProps={{
                                                        fullWidth: true,
                                                    }}
                                                    inputProps={{
                                                        onChange: event =>
                                                            this.change(event, "email", "email"),
                                                        value: this.state.email,

                                                    }}
                                                />
                                            </GridItem>
                                            <GridItem xs={12} sm={6} style={{marginTop: '10px'}}>
                                                <FormControl
                                                    fullWidth
                                                    className={classes.selectFormControl}>
                                                    <InputLabel
                                                        htmlFor="simple-select"
                                                        className={classes.selectLabel}>
                                                        Gender
                                                    </InputLabel>
                                                    <Select
                                                        MenuProps={{
                                                            className: classes.selectMenu
                                                        }}
                                                        classes={{
                                                            select: classes.select
                                                        }}
                                                        value={this.state.gender}
                                                        onChange={e => this.onChangeSelect(e)}
                                                        inputProps={{name: "gender", id: "gender"}}>
                                                        <MenuItem
                                                            disabled={true}
                                                            classes={{
                                                                root: classes.selectMenuItem,
                                                                selected: classes.selectMenuItemSelected
                                                            }}>
                                                            Select Gender
                                                        </MenuItem>
                                                        <MenuItem
                                                            classes={{root: classes.selectMenuItem}}
                                                            value="M">
                                                            Male </MenuItem>
                                                        <MenuItem
                                                            classes={{root: classes.selectMenuItem}}
                                                            value="F">
                                                            Female </MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </GridItem>
                                        </GridContainer>
                                        <GridContainer>
                                            <GridItem xs={12} sm={6}>

                                                <CustomInput
                                                    labelText="Age"
                                                    success={this.state.ageState === "success"}
                                                    error={this.state.ageState === "error"}
                                                    id="age"
                                                    formControlProps={{
                                                        fullWidth: true,
                                                        required: true
                                                    }}
                                                    inputProps={{
                                                        onChange: event =>
                                                            this.change(event, "age", "novalidation"),
                                                        value: this.state.age,

                                                    }}
                                                />

                                            </GridItem>

                                            <GridItem xs={12} sm={6}>
                                                <CustomInput
                                                    labelText="Custom Message"
                                                    success={this.state.custom_messageState === "success"}
                                                    error={this.state.custom_messageState === "error"}
                                                    id="custom_message"
                                                    formControlProps={{
                                                        fullWidth: true,
                                                        required: true
                                                    }}
                                                    inputProps={{
                                                        onChange: event =>
                                                            this.change(event, "custom_message", "novalidation"),
                                                        value: this.state.custom_message,

                                                    }}
                                                />
                                            </GridItem>
                                        </GridContainer>


                                        <h3>Services</h3>
                                        <GridItem>
                                            <GridContainer className={classes.justifyContentCenter}
                                                           style={{
                                                               justifyContent: 'center',
                                                               textAlign: 'center',
                                                               marginBottom: '20px'
                                                           }}>

                                                <ExpansionPanel className="width-full" defaultExpanded>
                                                    <ExpansionPanelSummary
                                                        expandIcon={<ExpandMoreIcon/>}
                                                        aria-controls="panel1a-content"
                                                        id="panel1a-header">
                                                        <Typography
                                                            className={classes.heading}>Services</Typography>
                                                    </ExpansionPanelSummary>
                                                    <ExpansionPanelDetails>
                                                        <Typography className="width-full" defaultExpanded>
                                                            {this.state.investigation.map((item, index) => {
                                                                return <div className="width-full list-inline"
                                                                            style={{display: 'inline-flex'}}
                                                                            key={"investigation" + index}>
                                                                    <GridItem xs={12} sm={6}>
                                                                        <FormControl
                                                                            fullWidth>
                                                                            <InputLabel
                                                                                htmlFor="clinic_id">
                                                                                Services
                                                                            </InputLabel>
                                                                            <Select
                                                                                value={item.name}
                                                                                onChange={e => this.handleChangeInvestigation(e, 'name', index)}
                                                                                inputProps={{
                                                                                    name: "name",
                                                                                    id: "name"
                                                                                }}
                                                                            >
                                                                                <MenuItem
                                                                                    disabled
                                                                                >
                                                                                    Select Service
                                                                                </MenuItem>
                                                                                {this.state.clinic_id !== "" && clinicsData.filter(a => a._id === this.state.clinic_id).length > 0 ? clinicsData.filter(a => a._id === this.state.clinic_id)[0].services.map((x) => {
                                                                                    return <MenuItem key={Math.random()}
                                                                                                     style={{height: "1.8em"}}
                                                                                                     value={x.service}>{x.service ? x.service : "No Name"}</MenuItem>
                                                                                }) : null}
                                                                            </Select>
                                                                        </FormControl>
                                                                    </GridItem>
                                                                    <GridItem xs={12} sm={6}>
                                                                        <TextField
                                                                            id="standard-name"
                                                                            label="Cost"
                                                                            className={classes.textField + " width-full"}
                                                                            value={item.rate}
                                                                            onChange={e => this.handleChangeInvestigation(e, 'rate', index)}
                                                                            margin="normal"
                                                                        /></GridItem>
                                                                </div>
                                                            })}
                                                            <GridItem xs={12} sm={6}>
                                                                <Button block size="lg" color="warning"
                                                                        onClick={(e) => this.addInvestigation(e)}>Add
                                                                    Services
                                                                </Button></GridItem>
                                                            <GridItem xs={12} sm={6}>
                                                            </GridItem>
                                                        </Typography>
                                                    </ExpansionPanelDetails>
                                                </ExpansionPanel>
                                            </GridContainer>
                                            <br/>
                                        </GridItem>

                                    </form>
                                </CardBody>
                                <CardFooter>
                                    <GridContainer className={classes.justifyContentCenter}>
                                        <GridItem xs={10} sm={3} md={2}>
                                            <Button block size="lg" color="warning" onClick={
                                                this.typeClick
                                            }>
                                                Save
                                            </Button>
                                        </GridItem>
                                        <GridItem xs={10} sm={3} md={2}>
                                            <NavLink to={dashboardRouter(`/reports/readReports`)}>
                                                <Button block size="lg" color="grey">
                                                    Cancel
                                                </Button>
                                            </NavLink>
                                        </GridItem>
                                    </GridContainer>
                                </CardFooter>
                            </Card>
                        </GridItem>
                    </GridContainer>
                    {/*<Button onClick={() => this.setState({open: true})}>Open Modal</Button>*/}

                    {/*<Modal*/}
                    {/*aria-labelledby="simple-modal-title"*/}
                    {/*aria-describedby="simple-modal-description"*/}
                    {/*open={true}*/}
                    {/*// onClose={() => this.setState({open: false})}*/}
                    {/*>*/}
                    {/*<div>*/}
                    {/*<Typography variant="h6" id="modal-title">*/}
                    {/*Text in a modal*/}
                    {/*</Typography>*/}
                    {/*<Typography variant="subtitle1" id="simple-modal-description">*/}
                    {/*Duis mollis, est non commodo luctus, nisi erat porttitor ligula.*/}
                    {/*</Typography>*/}
                    {/*</div>*/}
                    {/*</Modal>*/}
                </div>
            );
        else return (<div>
            <Loader/>
        </div>)
    }

    addInvestigation() {
        let a = [{name: "", rate: ""}];
        let b = this.state.investigation.concat(a);
        this.setState({investigation: b});
    }

    handleChangeInvestigation(e, name, index) {
        let a = this.state.investigation.slice(); //creates the clone of the state
        a[index][name] = e.target.value;
        this.setState({investigation: this.state.investigation})
    }

    saveInvestigation(value, type, index) {
        let a = this.state.investigation.slice(); //creates the clone of the state
        a[index][type] = value
        this.setState({investigation: this.state.investigation})

    }

    addMedication() {
        let a = [{name: "", dosage: "", frequency: "", instruction: ""}];
        let b = this.state.medication.concat(a);
        let c = ["days"];
        let d = this.state.duration.concat(c);
        this.setState({medication: b, duration: d});
    }


    onSelectDuration(name, index) {
        let a = this.state.medication.slice(); //creates the clone of the state
        let newDose = a[index][name];
        let newDosage = newDose.slice(0, 1)
        if (this.state.duration[index] === "days") {
            a[index][name] = newDosage + " weeks";
            this.state.duration[index] = "weeks"
            this.setState({duration: this.state.duration})
        } else if (this.state.duration[index] === "weeks") {
            a[index][name] = newDosage + " months";
            this.state.duration[index] = "months"
            this.setState({duration: this.state.duration})

        } else {
            a[index][name] = newDosage + " days";
            this.state.duration[index] = "days"
            this.setState({duration: this.state.duration})
        }
    }

    handleChangeMedication(e, name, index) {
        let a = this.state.medication.slice(); //creates the clone of the state
        if (name === "dosage") {
            a[index][name] = e.target.value.length === 1 ? e.target.value + " " + this.state.duration[index] : e.target.value;
        } else {
            a[index][name] = e.target.value;
        }
        this.setState({medication: this.state.medication})
    }

    saveMedication(value, type, index) {
        let a = this.state.medication.slice(); //creates the clone of the state
        a[index][type] = value
        this.setState({medication: this.state.medication})

    }

    addSecondaryContact() {
        let a = [""];
        let b = this.state.secondaryNumber.concat(a);
        this.setState({secondaryNumber: b})
    }

    handleChangeSecondayNumber(e, index) {
        this.state.secondaryNumber[index] = e.target.value;
        this.setState({secondaryNumber: this.state.secondaryNumber})
    }

    changeSecondaryNumbers(event, inputType, index) {
        let a = this.state.secondaryNumber.slice(); //creates the clone of the state
        a[index] = event.target.value;
        this.state.secondaryNumber[index] = event.target.value;
        this.setState({secondaryNumber: this.state.secondaryNumber});
        if ((event.target.value)) {
            let state = this.state;
            this.state.secondaryNumberState[index] = "success";
            this.setState(state);
        } else if (event.target.value === "" && inputType === "optional") {
            let state = this.state;
            this.state.secondaryNumberState[index] = "none";
            this.setState(state);
        } else {
            let state = this.state;
            this.state.secondaryNumberState[index] = "error";
            this.setState(state);
        }
    }

    change(event, stateName, type, inputType, maxValue) {
        this.setState({[stateName]: event.target.value});
        switch (type) {
            case "email":
                if (verifyEmail(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "") {
                    this.setState({[stateName + "State"]: ""});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "name":
                if (verifyName(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "") {
                    this.setState({[stateName + "State"]: ""});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "phonenumber":
                if (verifyPhoneNumber(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "") {
                    this.setState({[stateName + "State"]: ""});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "alphanum":
                if (verifyAlphaNum(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "") {
                    this.setState({[stateName + "State"]: ""});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "number":
                if (verifyNumber(event.target.value)) {
                    this.setState({[stateName + "State"]: "success"});
                } else if (event.target.value === "") {
                    this.setState({[stateName + "State"]: ""});
                } else {
                    this.setState({[stateName + "State"]: "error"});
                }
                break;
            case "novalidation":
                if (event.target.value === "" && inputType === "optional") {
                    this.setState({[stateName + "State"]: "none"});
                } else if (event.target.value === "" && inputType === "required") {
                    this.setState({[stateName + "State"]: "error"});
                } else {
                    this.setState({[stateName + "State"]: "success"});
                }
                break;
            default:
                break;
        }
    }

    typeClick() {
        if (this.state.clinic_id === "") {
            this.setState({titleState: "error"});
            this.props.id.generateNotification({message: "Please fill the clinic!", color: "danger"});

        } else if (this.state.clickedId === "") {
            this.setState({titleState: "error"});
            this.props.id.generateNotification({message: "Please fill the patient details!", color: "danger"});

        } else if (this.state.clinicmaster_id === "") {
            this.setState({titleState: "error"});
            this.props.id.generateNotification({message: "Please fill the clinic master!", color: "danger"});

        } else if (this.state.name === "") {
            this.setState({titleState: "error"});
            this.props.id.generateNotification({message: "Please fill the patient details!", color: "danger"});

        } else if (this.state.clinic_id !== "" && this.state.name && this.state.autoCompleteValue && this.state.clinicmaster_id && this.state.autoCompleteReportValue !== "") {
            var data = {
                "clinic_master_id": this.state.clinicmaster_id,
                "clinic_id": this.state.clinic_id,
                "patient_id": this.state.clickedId,
                "user_id": this.state.clickedId,
                "doctor_id": "",
                "services": this.state.investigation,
                "custom_message": this.state.custom_message,
                "invoice_number": this.state.invoice_number,
                "paid": this.state.checkedA,
                "name": this.state.name,
                "contact": this.state.autoCompleteValue,
                "email": this.state.email,
                "date": currentDate(),
                "docs": []
                // "docs": this.state.secondaryNumber.filter(function (value, index, arr) {
                //     return value !== "";
                // }).map(item => {
                //     return {
                //         "sign": this.state.doctorList.filter(a => a.user_details.name === item)[0].doctor_clinics.filter(b => b.clinic_id._id === this.state.clinic_id)[0].signature ? this.state.doctorList.filter(a => a.user_details.name === item)[0].doctor_clinics.filter(b => b.clinic_id._id === this.state.clinic_id)[0].signature : "Doctor",
                //         "name": item
                //     }
                // })
            };
            // var data = {
            //     "clinic_id": this.state.clinic_id,
            //     "name": this.state.name,
            //     "contact": this.state.autoCompleteValue,
            //     "email": this.state.email,
            //     "title": this.state.autoCompleteReportValue,
            //     "clinic_master_id": this.state.clinicmaster_id,
            //     "appointment_id": "",
            //     "amount": "",
            //     "date": new Date().getTime(),
            //     "paid": this.state.checkedA,
            //     "gender": this.state.gender,
            //     "age": this.state.age,
            //     "remark": this.state.remarks,
            //     "description": this.state.description,
            //     "type": `${this.state.simpleSelect !== "" ? this.state.simpleSelect : "Others"}`,
            //     "ref_by": this.state.ref_by,
            //     "save_template": this.state.save_template,

            // };
            api.createBill(data).then(json => {
                if (json.data.isError) {
                    var msgcolor = {message: json.data.message.message, color: "danger"};
                    this.props.id.generateNotification(msgcolor);
                } else {
                    this.setState({redirect: true});
                    var msgcolor = {message: "Bill Added Successfully!", color: "success"};
                    this.props.id.generateNotification(msgcolor);
                    this.setState();
                    this.props.id.history.push(dashboardRouter(`/bill/view/${json.data.data._id}`));
                }
            }).catch(error => {
                var msgcolor = {message: "Server Error!", color: "danger"};
                this.props.id.generateNotification(msgcolor);
            })
        } else {
            var msgcolor = {message: "Some fields are empty!", color: "danger"};
            this.props.id.generateNotification(msgcolor);
        }
    }

    getMyclinicFromClicnicMaster(id) {
        api.getClinicDetailsFromMaster(id).then(json => {
            this.setState({clinicsData: json.data.data.clinicmaster_clinics})
        }).catch(error => {
            this.props.serverError(true);
        })
        ;
    }

    handleChange = name => event => {
        this.setState({[name]: event.target.checked});
    };

}


const mapStateToProps = ({global}) => ({
    searchPrescription: global.searchPrescription,
});

const mapDispatchToProps = dispatch => bindActionCreators({
    saveSearchPrescription,
    serverError
}, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(withStyles(validationFormsStyle)(CreateBilling));



// WEBPACK FOOTER //
// ./src/components/Billing/createBilling.jsx